<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="8">功能选择</el-col>
      <el-col :span="16"style="text-align: center;width: 40%;">列表</el-col>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"

              :value="item.value">
            </el-option>
          </el-select>
          <input type="text" v-model="search" @change="onChangeStripe()" style="height: 32px;"/>
      </el-col>

      <el-col :span="16" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 40%;">


        <el-row  class="tui-el">
          <el-col :span="10" style="text-align: center;">名称</el-col>
          <el-col :span="10" style="text-align: center;">图片</el-col>
          <el-col :span="4" style="text-align: center;">操作</el-col>
        </el-row>
        <el-row  class="tui-el">
          <el-col :span="10" style="text-align: center;line-height: 60px;"><input type="text" v-model="newName"></el-col>
          <el-col :span="10" style="text-align: center;">
            <el-upload
              class="avatar-uploader"
              action="http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
              :show-file-list="false"
              :on-success="handleAvatarSuccess1"
              style="display: inline;">

              <img v-if="addImg" :src="addImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-col>
          <el-col :span="4" ><input type="button" style="position: absolute;right: 0px;top: 15px;" @click="add()" value="添加"></el-col>
        </el-row>
        <el-row  class="tui-el" v-for="(item,index) in list" :key="index">
          <el-col :span="10" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>
          <el-col :span="10" style="text-align: center;">
            <el-upload
              class="avatar-uploader"

              :action="UploadUrl(item.id)"
              :show-file-list="false"
              @click.native="ceshi(index,item.id)"
              :on-success="handleAvatarSuccess">

              <img v-if="item.img" :src="item.img" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
          <el-col :span="4" style="text-align: center;" @click.native="del(item.id,index)">删除</el-col>
        </el-row>
      </el-col>


    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: '',
        addImg:'',
        addImgs:'',
        newName:'',
        imageId: 0,
        list: [{
          img: 'http://fencip.yoooooo.com/static/xitong/zhishiwenda.png',

          name: '黄金糕'
        }, {
          img: 'http://fencip.yoooooo.com/static/xitong/shici.png',

          name: '双皮奶'
        }, {
          img: 'http://fencip.yoooooo.com/static/xitong/changtuqiche.png',

          name: '蚵仔煎'
        }],
        search:'',
        imgId:0

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{
    UploadUrl(id){
      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSave"
      // return "http://fencip.yoooooo.com/index.php/index/data/pythonImageChange?id="+id
    },
    onChangeStripe(){
      this.loadList()
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/ImgsList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']
        this.loadList()
    	})
    	.catch(err=>{

    	});
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          l_id:this.value,
          name:this.search
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/ImgsLists'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },
    handleAvatarSuccess1(res, file){


      this.addImg = URL.createObjectURL(file.raw);
      this.addImgs = file.response.data
      console.log(this.addImgs)
    },
    handleAvatarSuccess(res, file) {

      this.imgChange(this.imgId,file.response.data)
      this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
      // this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },
    imgChange(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img
    
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImageChangeNew'
      })
      .then(res=>{
    
    
        this.list[this.imageId]['img'] = res.data.data
    
    
    
    
      })
      .catch(err=>{
    
      });
    },
    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/ImgsDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.addImgs == ''){
        this.msg('请选择图片','error')
        return false
      }
      console.log(this.addImgs)
      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/ImgsAdd',
      	params:{
      		name:this.newName,
      		url:this.addImgs,
          l_id:this.value
      	}
      })
      .then(res=>{
      	this.tableData = res.data.data
        this.addImgs = ''
        this.addImg = ''
        this.newName = ''
        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/image.vue